module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/marketplace-coupons/marketplace-coupons.component.css
// module id = ./src/app/components/marketplace-coupons/marketplace-coupons.component.css
// module chunks = main